<template>
  <v-list class="pt-0" dense >
    <v-list-tile v-for="item in items" :key="item.title" router :to="item.path">
      <v-list-tile-action>
        <v-tooltip bottom>
          <v-icon slot="activator">{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import menu from '../config/menu.js'

export default {
  data () {
    return {
      height: '',
      items: menu.items
    }
  },
  methods: {
    hasAccess (allowedRoles) {
      if (!allowedRoles || allowedRoles.length === 0) {
        return true
      }
      return this.roles.filter(function (value) {
        return allowedRoles.indexOf(value) > -1
      }).length > 0
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SidebarMenu.vue